export default __webpack_public_path__ + "static/media/product-placeholder.2218bee2.jpg";